import { Component, OnInit, inject } from '@angular/core';
import { UserStat } from 'app/core/models/user-stat.model';
import { MyStatsService } from 'app/core/services/my-stats.service';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-user-stats',
    templateUrl: './user-stats.component.html',
    styleUrls: ['./user-stats.component.scss'],
    imports: [FaIconComponent]
})
export class UserStatsComponent implements OnInit {
  private myStatsService = inject(MyStatsService);

  faxStat: UserStat;
  gatherEvidenceBlockedStat: UserStat;
  consultNoteStat: UserStat;
  verifiedCaptureStat: UserStat;

  ngOnInit() {
    this.init();
  }

  private init() {
    this.myStatsService.getFaxes().subscribe(result => {
      this.faxStat = result;
    });

    this.myStatsService.getGatherEvidenceBlocked().subscribe(result => {
      this.gatherEvidenceBlockedStat = result;
    });

    this.myStatsService.getConsultNote().subscribe(result => {
      this.consultNoteStat = result;
    });

    this.myStatsService.getVerifiedCapture().subscribe(result => {
      this.verifiedCaptureStat = result;
    });
  }

}
